<section>
	<div>
		<div class="title-dav">
			<h1 class="center">
				DAV
			</h1>
			<h3 *ngIf="dav && dav.date_derniere_maj" class="center">Date de la dernière mise à jour :
				{{dav.date_derniere_maj | date:
				'dd/MM/yyyy'}}</h3>
			<h3 *ngIf="!dav || !dav.date_derniere_maj" class="center">Aucune mise à jour n'a déjà été téléchargée</h3>
		</div>
		<div class="page-dav">
			<mat-grid-list cols="3" rowHeight="1.35:1" gutterSize="20px">
				<mat-grid-tile class="click" (click)="this.select='downloadMaj'"
					[ngClass]="select==='downloadMaj' ? 'selected' : ''"
					[ngClass]="majToday ? 'disabled' : ''"
				>
					<mat-grid-tile-header>Fichier de mise à jour</mat-grid-tile-header>
					<mat-icon svgIcon="download"></mat-icon>
				</mat-grid-tile>
				<mat-grid-tile class="click" (click)="this.select='reDownloadMaj'" [ngClass]="select==='reDownloadMaj' ? 'selected' : ''">
					<mat-grid-tile-header>Fichier de la mise à jour précédente</mat-grid-tile-header>
					<mat-icon svgIcon="re-download"></mat-icon>
				</mat-grid-tile>
				<mat-grid-tile class="click" (click)="this.select='downloadPuces'" [ngClass]="select==='downloadPuces' ? 'selected' : ''">
					<mat-grid-tile-header>Base complète</mat-grid-tile-header>
					<mat-icon svgIcon="all"></mat-icon>
				</mat-grid-tile>
			</mat-grid-list>
		</div>
		<div class="button-dav">
			<button mat-raised-button
				[disabled]="select == '' || loading || (currentClient ? !currentClient.dav : true)"
				(click)="download()">
				<mat-spinner diameter="20" *ngIf="loading"></mat-spinner>Télécharger
			</button>
		</div>
	</div>
</section>